<template>
  <main-logo-register class="logo__main" />

  <div>
    <section class="container">
      <div class="container__info">
        <span class="name">¡Ups! Tu Token ha vencido</span>
      </div>
      <div class="information">
        <p class="info">
          La invitación para unirte al equipo de trabajo "{{ workspaceData?.name }}" ha
        </p>
        <p class="info">
          vencido debido a que han transcurrido más de “24 horas” desde que fue enviada.
        </p>
        <p class="info">
          Por favor, comunícate con tu líder de equipo para que pueda actualizar tu invitación.
        </p>
        <p class="team">¡Te esperamos con ansias en tu equipo de trabajo!</p>
      </div>
      <div class="separator"></div>
    </section>
    <section class="drawing">
      <img src="@/app/register/assets/padlock.png" alt="padlock" />
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import { useValidateWorkspace } from "@/app/auth/composables/useValidateWorkspace";

import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";

export default defineComponent({
  components: {
    MainLogoRegister,
  },
  setup() {
    const workspaceData = useValidateWorkspace();

    return { workspaceData };
  },
  data() {
    return {
      loading: false,
      password: "",
      workspace: "",
    };
  },
});
</script>

<style lang="sass" scoped>


.container
  text-align: center

.drawing
  margin-top: 50px
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 90px
  text-align: center
  margin-bottom: 20px

.name
  font-weight: 600
  font-size: 30px

.separator
  margin-bottom: 30px

.button
  width: 100%

.information
  font-size: 20px
  color: $gray-9

.logo__main
  background-color: $white
  padding: 12px 0 0
  margin-top: -20px

.background
  background-color: $background-main

.info
  margin: 0

.team
  margin-top: 30px
</style>
